"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletionChoice = void 0;
class CompletionChoice {
    constructor() {
    }
    static getAttributeTypeMap() {
        return CompletionChoice.attributeTypeMap;
    }
}
exports.CompletionChoice = CompletionChoice;
CompletionChoice.discriminator = undefined;
CompletionChoice.attributeTypeMap = [
    {
        "name": "finishReason",
        "baseName": "finish_reason",
        "type": "string",
        "format": ""
    },
    {
        "name": "index",
        "baseName": "index",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "message",
        "baseName": "message",
        "type": "CompletionMessage",
        "format": ""
    }
];
//# sourceMappingURL=CompletionChoice.js.map